import { lowerFirst } from './string';
/**
 * @param {string} prefix
 * @param {string} value
 */

var unprefixPropName = function unprefixPropName(prefix, value) {
  return lowerFirst(value.replace(prefix, ''));
};

export default unprefixPropName;


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/esm/utils/unprefix-prop-name.js
// module id = 861
// module chunks = 0